module.exports = __webpack_public_path__ + "img/Cheer Megaphone43.f10f054e.jpg";